var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#A1A1AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 6.66663C16.508 6.66663 13.668 9.50663 13.668 13C13.668 16.4266 16.348 19.2 19.8413 19.32C19.948 19.3066 20.0546 19.3066 20.1346 19.32C20.1613 19.32 20.1746 19.32 20.2013 19.32C20.2146 19.32 20.2146 19.32 20.228 19.32C23.6413 19.2 26.3213 16.4266 26.3346 13C26.3346 9.50663 23.4946 6.66663 20.0013 6.66663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7742 22.8652C23.0542 20.3852 16.9876 20.3852 13.2409 22.8652C11.5476 23.9986 10.6143 25.5319 10.6143 27.1719C10.6143 28.8119 11.5476 30.3319 13.2276 31.4519C15.0943 32.7052 17.5475 33.3319 20.0009 33.3319C22.4542 33.3319 24.9075 32.7052 26.7742 31.4519C28.4542 30.3186 29.3875 28.7986 29.3875 27.1452C29.3742 25.5052 28.4542 23.9852 26.7742 22.8652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.95212444981444fd7cd7f4831f23f54a.svg";
export { ForwardRef as ReactComponent };